import ApplicationController from '../../../javascript/controllers/application_controller'

export default class extends ApplicationController {
  remove(event) {
    if (!event.target.hasChildNodes()) event.target.remove()
  }
}
